import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tableRows", "excludeCentralizedCheckBox", "excludeTradingIncentivesCheckBox"];

  connect() {}

  filterExchanges() {
    var tableRows = this.tableRowsTarget;

    for(let row of tableRows.querySelectorAll("tr")){
      if (this.excludeTradingIncentivesCheckBoxTarget.checked && row.dataset.hasTradingIncentive === 'true') {
        row.style.display = "none"
      } else if (this.excludeCentralizedCheckBoxTarget.checked && row.dataset.isCentralized === 'true') {
        row.style.display = "none"
      } else {
        row.style.display = ""
      }
    }
  }

  executeFilter(event) {
    var country = event.target.getAttribute("data-country");
    var settlement = event.target.getAttribute("data-settlement");
    var product_type = event.target.getAttribute("data-product-type");

    var searchParams = new URLSearchParams("");
    if (settlement != null) {
      searchParams.append("settlement", settlement);
    } else {
      searchParams.delete("settlement");
    }
    if (product_type != null) {
      searchParams.append("product_type", product_type);
    } else {
      searchParams.delete("product_type");
    }
    if (country != null) {
      searchParams.append("country", country);
    } else {
      searchParams.delete("country");
    }

    window.location.search = searchParams.toString();
  }
}
